<template>
  <div>
    <div class="news-page page" v-if="displayNewsList">
      <!-- 顶部1 -->
      <page-top></page-top>
      <!-- 头部 -->
      <Header></Header>
      <!-- 主体 -->
      <main class="main">
        <section class="breadcrumb-plate w">
          <div class="label">当前位置：</div>
          <breadcrumb />
        </section>
        <section class="content w">
          <div class="c-left">
            <tabbar :tabData="tabList" :code="categoryId" :seccode="seccode" :subcode="subcode"
              @changeSecTab="changeSecTab"></tabbar>
          </div>
          <div class="c-right" v-if="pageType == 1">
            <div class="article-content" v-html="articleData"></div>
          </div>
          <div class="c-right" v-if="pageType == 2">
            <list-item :list="newsList" type="arrows" :dash="true" @toDetail="toDetail"></list-item>

            <div class="m-bot" v-if="newsList.list?.length > 0 && pageCount >= pageSize">
              <el-pagination background layout="prev, pager, next" prev-text="上一页" next-text="下一页" :page-size="pageSize"
                :total="pageCount" @current-change="changePageClick">
              </el-pagination>
            </div>
            <el-empty description="暂无相关信息" v-if="newsList.list?.length == 0" style="height: 492px"></el-empty>
          </div>
        </section>
      </main>
      <!-- 底部 -->
      <Footer></Footer>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import pageTop from "@/components/common/pageTop.vue";
import Header from "@/components/common/header.vue";
import Footer from "@/components/common/footer.vue";
import Tabbar from "@/components/list/tabbar.vue";
import listItem from "@/components/list/list-item.vue";

import Breadcrumb from "@/components/common/breadcrumb";
import { getArticleById, getArticlePage } from "@/api/home/home.js";
import { getNavItemByCode } from "@/api/common/common.js";

export default {
  components: { pageTop, Header, Footer, Tabbar, Breadcrumb, listItem },
  data() {
    return {
      pageSize: 10, //分页数量
      pageCount: 0, //列表总数
      displayNewsList: true,

      tabList: [],
      tabTitle: "新闻中心",
      newsList: [],
      articleData: "",
      pageType: "", //1 文章内容，2 文章列表
      categoryId: "",
      tabcode: "",
      seccode: "",
      subcode: ""
    };
  },
  created() {
    console.log("--list--query--", this.$route.query);

    this.pageType = this.$route.query?.linkType;
    let id = this.$route.query?.id;
    this.categoryId = this.$route.query?.categoryId;
    this.tabcode = this.$route.query?.tabcode;
    this.seccode = this.$route.query?.seccode;
    this.fetchData();
    if (id != "null" && id) return this.getArticleData(id);
  },
  methods: {
    //统一获取数据
    fetchData() {
      if (!this.tabcode) return;

      getNavItemByCode(this.tabcode).then((res) => {
        if (!res.data) return;
        //侧边栏列表
        this.tabList = res.data[0];
        //路由判断目标栏目
        if (this.tabList?.list &&this.tabList?.list.length == 0) return  this.getArticlePage();
        const targetItem = this.tabList?.list?.find(item => item.categoryCode == this.seccode);

        if (!targetItem || !targetItem.list || targetItem.list.length === 0) return  this.getArticlePage();
        //点击二级标题，默认展示第一个三级栏目
        this.seccode = targetItem.categoryCode;
        this.categoryId = this.categoryId == this.seccode ? targetItem.list[0].categoryCode : this.categoryId;
        this.subcode = this.categoryId;

        //选中侧边副标题
        const secItem = targetItem.list.find(item => item.categoryCode == this.categoryId);
        // console.log("--三级--二级--changesecTab", this.categoryId, this.seccode, this.subcode, secItem);
        if (secItem) {
          if (secItem.linkType == 1) {
            this.getArticleData(secItem.linkUrl);
          } else {
            console.log("secItem--this.categoryId",this.categoryId);
            this.getArticlePage();
          }
          return;
        }
      });
    },
    // 文章信息--富文本
    getArticleData(id) {
      getArticleById(id).then((res) => {
        if (!res.data) return;
        this.articleData = res.data.articleContent;
      });
    },
    //获取文章列表
    getArticlePage(page = 1) {
      getArticlePage({
        page: page,
        limit: this.pageSize,
        categoryCode: this.categoryId,
      }).then((res) => {
        if (!res.data) return;
        this.newsList = res.data;
        this.pageCount = Number(res.data.count);
      });
    },
    //点击改变栏目
    changeSecTab(item, tab) {
      console.log("item111tab", item, tab);

      let url = "/newsList?categoryId=" + item.categoryCode + "&linkType=" + item.linkType + "&tabcode=" + this.tabcode
      url = tab ? url + '&seccode=' + tab : url

      this.seccode = tab//二级标题
      this.categoryId = item.categoryCode;//当前标题
      this.subcode = item.categoryCode;//三级标题
      this.pageType = item.linkType;
      if (this.tabList.list && this.tabList.list.length > 0) {
      const targetItem = this.tabList.list.find(item => item.categoryCode == this.categoryId);

      if (this.categoryId == this.seccode && targetItem?.list?.length) {
        item = item.list[0]
        this.seccode = targetItem.categoryCode;
        this.subcode = targetItem.list[0].categoryCode;
        this.categoryId = targetItem.list[0].categoryCode;
      }
    }
      // 展示富文本
      if (item.linkType == 1) {
        this.getArticleData(item.linkUrl);
        url = url + '&id=' + item.linkUrl
      }
      // 展示列表
      else if (item.linkType == 2) {
        this.getArticlePage();
      }

      this.$router.push({
        path: url,
      });
    },
    //切换页面
    changePageClick(page) {
      this.getArticlePage(page);
    },
    //跳转详情
    toDetail(item, code) {
      this.displayNewsList = false;
      this.$router.push({
        path: "/newsList/newsDetail/" + item.articleId + '/' + code,
      });
    },
  },
  mounted() { },
  watch: {
    //监听路由，处理嵌套路由问题
    $route: {
      handler() {
        if (this.$route.path == "/newsList") {
          this.displayNewsList = true;
        } else {
          this.displayNewsList = false;
        }
      },
      // 一进页面就执行
      immediate: true,
      // 深度观察监听
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.news-page {
  .main {
    flex: 1;
    padding-bottom: 80px;
    background-color: #fff;

    .breadcrumb-plate {
      display: flex;
      align-items: center;
      padding: 16px 0;

      .label {
        line-height: 1;
        font-size: 14px;
      }

      .el-breadcrumb {
        cursor: pointer;

        /deep/ .el-breadcrumb__inner.is-link {
          font-weight: normal;
        }
      }
    }

    .content {
      display: flex;
      justify-content: space-between;
      align-items: stretch;

      .c-left {
        width: 270px;
        flex-shrink: 0;

        margin-right: 15px;
        background-color: #fff;
        // box-shadow: 0 2px 2px rgba($color: #000000, $alpha: 0.05);
        box-shadow: 0px 2px 2px #edeef0;

        .list {}
      }

      .c-right {
        flex: 1;
        box-shadow: 0px 2px 2px #edeef0;

        .article-content {
          padding: 0 14px 20px 12px;
          font-size: 17px !important;
          line-height: 2 !important;
          min-height: 640px;
        }

        .m-bot {
          margin-top: 24px;
          margin-bottom: 24px;

          .el-pagination {
            display: flex;
            justify-content: center;

            /deep/ .btn-prev {
              width: 100px;
              height: 40px;
              border: 1px solid #e4e4e4;
              background-color: #fff;
            }

            /deep/ .btn-prev:hover:enabled {
              color: #409eff;
            }

            /deep/ .number {
              width: 40px;
              height: 40px;
              line-height: 40px;
              border: 1px solid #e4e4e4;
              background-color: #fff;
            }

            /deep/ .more {
              width: 40px;
              height: 40px;
              line-height: 40px;
              border: 1px solid #e4e4e4;
              background-color: #fff;
            }

            /deep/ .btn-next {
              width: 100px;
              height: 40px;
              border: 1px solid #e4e4e4;
              background-color: #fff;
            }

            /deep/ .btn-next:hover:enabled {
              color: #409eff;
            }

            /deep/ .active {
              color: #fff;
              background-color: #409eff;
            }
          }
        }
      }
    }
  }
}
</style>
